export const mainMenuNavigation = () => {

    const menuItems = document.querySelectorAll(".header__menu-list-item")  

    if (menuItems) {

        // console.log(" >>>> location = ", window.location.pathname)

        menuItems.forEach( (el) => {

            let menuItemsLink = el.querySelectorAll("a")
            let menuDropdown = el.querySelector(".header__menu-dropdown-name")

            menuItemsLink.forEach( (a) => {
            
                // console.log("href = ", a.getAttribute("href"))  
                
                if ((a.getAttribute("href") + "/" === window.location.pathname) && (menuDropdown)) {             
                    menuDropdown.classList.add("active-menu")               
                } 

                if (a.getAttribute("href") + "/" === window.location.pathname) {             
                    a.classList.add("active-menu")               
                } 

            })    
                        
        })

    }
}